<template lang="pug">
.loader-wrapper(v-if="loading || error")
    .overlay

    .loader-body.p-a
        button.btn.btn-sm.white(v-if="error" @click="retry()") Retry

        .loading(v-if="!error")
            .loading-spinner
</template>

<script>
export default {
    props: {
        error: {
            required: false,
            type: Boolean,
            default: false,
        },

        loading: {
            required: true,
            type: Boolean,
            default: false,
        },
    },

    methods: {
        retry() {
            this.$emit('retry');
        },
    },
};
</script>

<style lang="scss" scoped>
.loader-wrapper {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;

    .loader-body {
        align-items: center;
        display: flex;
        justify-content: center;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
    }

    .loading {
        line-height: 1;
        text-align: center;
    }

    .overlay {
        background-color: white;
        opacity: 0.8;
        width: 100%;
        height: 100%;
    }
}
</style>
